import React from "react";
import {
  HeadingFour,
  Paragraph1,
  Paragraph3,
  Paragraph2,
  HeadingFive,
} from "../components/typography";

function AboutUs() {
  const team_members_main = [
    { id: 0, name: "Dr Shahzad Rasool", post: "Principal Investigator" },
  ];

  const team_members_phd = [
    { id: 1, name: "Muhammad Ali Talay", post: "PhD Student" },
    { id: 2, name: "Amna Khan", post: "PhD Student" },
  ];
  const team_members_masters = [
    { id: 3, name: "Mian M Fatik Owais", post: "MS Student" },
    { id: 4, name: "Amna Naeem", post: "MS Student" },
    { id: 5, name: "Maira Sohail", post: "MS Student" },
    { id: 6, name: "Fiza Azam", post: "MS Student" },
    { id: 7, name: "Sofia Muhammad", post: "MS Student" },
    { id: 8, name: "Urwa Ijaz", post: "MS Student" },
    { id: 9, name: "Raheela Raza", post: "MS Student" },
  ];

  const team_members_research = [
    { id: 10, name: "Yumna Babar", post: "Research Staff" },
    { id: 11, name: "M Shaheer Khan", post: "Research Staff" },
    { id: 12, name: "Mansoor Khan ", post: "Research Staff" },
    { id: 13, name: "Mian Shah Hassan", post: "Research Staff" },
  ];

  const alumni = [
    {
      name: "Maria Maqbool",
      year: "2021-2023",
      topic:
        "Empowering eco-friendly habits - Designing interactive virtual environments for attitude and behaviour change towards energy conservation",
    },
    {
      name: "Kiran Firdaus",
      year: "2022-2023",
      topic:
        "Human stress classification using EEG in response to stand-up comedians’ clips",
    },
    {
      name: "Irsa Abbasi",
      year: "2020-2023",
      topic:
        "Developing a virtual reality approach towards a better understanding of different types of enzymes",
    },
    {
      name: "Ahmad Javaid",
      year: "2021-2022",
      topic:
        "Analysis of vestibulo-ocular effects on motion sickness in flight simulation",
    },
    {
      name: "Syeda Yumna Nasir",
      year: "2020-2022",
      topic:
        "Pseudo-haptic feedback through mid-air action for learning of chemical bond strengths",
    },
    {
      name: "Hafsa Tahir ",
      year: "2020-2022",
      topic:
        "Force feedback for collision avoidance in UAV teleportation through virtual corridors",
    },
    {
      name: "Amna Khan",
      year: "2021-2021",
      topic: "Game-induced emotion analysis using electroencephalography",
    },
    {
      name: "Neelam Shoaib",
      year: "2020-2021",
      topic:
        "Virtual reality based procedural memorization of general aviation light aircraft",
    },
    {
      name: "Attia Nafees ul Haq",
      year: "2020-2021",
      topic: "Pure mental state detection using EEG",
    },
    {
      name: "Muhammad Ali Bilal",
      year: "2018-2021",
      topic: "Cognitive workload analysis in visual and auditory task using EEG signals",
    },
    { 
      name: "Neelam Shoaib",
      year: "2020-2021",
      topic: "Virtual reality based procedural memorization of general aviation light aircraft" },
    {
      name: "Umar Shahid",
      year: "2019-2020",
      topic: "EEG based mental workload assessment using machine learning",
    },
    {
      name: "Muhammad Adil Talay",
      year: "2018-2020",
      topic:
        "Few-shot metric learning for remote sensing image scene classification",
    },
    {
      name: "Zain ul Abideen",
      year: "2018-2020",
      topic:
        "Development of a cost effective training system for small arms shooting training",
    },
    {
      name: "Hassam Ahmed Malik",
      year: "2018-2020",
      topic:
        "Effect of haptic feedback on pilot/operator performance during flight simulation",
    },
    {
      name: "Amal Fatemah ",
      year: "2018-2019",
      topic:
        "Design of an integrated pipeline for the visualization of 3D molecular models to study the effects on spatial learning ability",
    },
    {
      name: "Hasnain Rashid",
      year: "2017-2019",
      topic:
        "Automatic cell detection and counting of microscopic images using machine learning",
    },
    {
      name: "Aroosh Fatima ",
      year: "2017-2018",
      topic: "Using deep learning for image and video vompression",
    },
    {
      name: "Syed Rameez Rehman",
      year: "2016-2018",
      topic: "A framework for cardboard based augmented reality",
    },
    {
      name: "Samin Kainat",
      year: "2016-2017",
      topic: "Man made world image matching over wide baselines",
    },
  ];

  return (
    <section className="bg-white ">
      <div className="py-3 px-4 mx-auto max-w-screen-xl text-center lg:pt-16 lg:px-6">
        <div className="mx-auto mb-8 max-w-screen-sm lg:mb-16">
          <HeadingFour className="mb-4 tracking-widest font-bold text-[--secondary-heading-font-color]">
            Members
          </HeadingFour>
          <Paragraph1 className="text-[--secondary-heading-font-color]">
            The lab is headed by a PI who leads a team of research staff and students.
          </Paragraph1>
        </div>

        <HeadingFour className="mb-12">Principal Investigator</HeadingFour>
        <div className="flex flex-wrap justify-center  mx-4">
          {team_members_main.map((item, index) => (
            <div key={index} className="text-center  mx-8 mb-8">
              <img
                className="mx-auto mb-4 w-36 h-36 rounded-full"
                src="https://static.vecteezy.com/system/resources/thumbnails/003/337/584/small/default-avatar-photo-placeholder-profile-icon-vector.jpg"
                alt=""
              />
              <Paragraph1 className="mb-1  text-[--secondary-heading-font-color] font-semibold">
                <a href="/">{item.name}</a>
              </Paragraph1>
              <Paragraph2>{item.post}</Paragraph2>
            </div>
          ))}
        </div>

        <HeadingFour className="mb-12">PhD Students</HeadingFour>
        <div className="flex flex-wrap justify-center mx-4">
          {team_members_phd.map((item, index) => (
            <div key={index} className="text-center  mx-8 mb-8">
              <img
                className="mx-auto mb-4 w-36 h-36 rounded-full"
                src="https://static.vecteezy.com/system/resources/thumbnails/003/337/584/small/default-avatar-photo-placeholder-profile-icon-vector.jpg"
                alt=""
              />
              <Paragraph1 className="mb-1 text-[--secondary-heading-font-color] font-semibold">
                <a href="/">{item.name}</a>
              </Paragraph1>
              <Paragraph2>{item.post}</Paragraph2>
            </div>
          ))}
        </div>

        <HeadingFour className="mb-12">Masters Students</HeadingFour>
        <div className="flex flex-wrap justify-center mx-4">
          {team_members_masters.map((item, index) => (
            <div key={index} className="text-center  mx-8 mb-8">
              <img
                className="mx-auto mb-4 w-36 h-36 rounded-full"
                src="https://static.vecteezy.com/system/resources/thumbnails/003/337/584/small/default-avatar-photo-placeholder-profile-icon-vector.jpg"
                alt=""
              />
              <Paragraph1 className="mb-1 text-[--secondary-heading-font-color] font-semibold">
                <a href="/">{item.name}</a>
              </Paragraph1>
              <Paragraph2>{item.post}</Paragraph2>
            </div>
          ))}
        </div>

        <HeadingFour className="mb-12">Research Staff</HeadingFour>
        <div className="flex flex-wrap justify-center mx-4">
          {team_members_research.map((item, index) => (
            <div key={index} className="text-center  mx-8 mb-8">
              <img
                className="mx-auto mb-4 w-36 h-36 rounded-full"
                src="https://static.vecteezy.com/system/resources/thumbnails/003/337/584/small/default-avatar-photo-placeholder-profile-icon-vector.jpg"
                alt=""
              />
              <Paragraph1 className="mb-1 text-[--secondary-heading-font-color] font-semibold">
                <a href="/">{item.name}</a>
              </Paragraph1>
              <Paragraph2>{item.post}</Paragraph2>
            </div>
          ))}
        </div>
      </div>

      <div className="py-4 px-4 mx-auto max-w-screen-xl  lg:px-6">
        <div className="mb-3 max-w-screen-sm">
          <HeadingFive className="mb-4 text-[--secondary-heading-font-color]">
            Alumni
          </HeadingFive>
          <Paragraph1 className="font-light text-[--secondary-heading-font-color]">
            The HIVE is proud to have had the following members as part of the team.
          </Paragraph1>
        </div>
        {alumni.map((item, index) => (
          <div key={index} className="py-2">
            <Paragraph1 className="mb-1 font-bold">
              <a href="/">
                {index + 1}. {item.name}
              </a>
            </Paragraph1>
            <Paragraph3>{item.year}</Paragraph3>
            <Paragraph3>{item.topic}</Paragraph3>
          </div>
        ))}
      </div>
    </section>
  );
}

export default AboutUs;
